import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";

import Layout from "./components/Layout";
import Header from "./components/Header";
import StaffLogin from "./pages/StaffLogin";

import Dashboard from "./pages/Dashboard";
import MemberRegistration from "./pages/MemberRegistration";
import MemberDetail from "./pages/MemberDetail";
import GroupDetails from "./pages/GroupDetails";
import OpenSaving from "./pages/OpenSaving";
import SavingLedger from "./pages/SavingLedger";
import DayBook from "./pages/DayBook";
import DueMembers from "./pages/DueMembers";
import AdvanceMembers from "./pages/AdvanceMembers";
import CreateStaff from "./pages/CreateStaff";
import StaffList from "./pages/StaffList";
import Offers from "./pages/Offers";

// 🔥 NEW – ADMIN FUND TRANSFER
import FundTransfer from "./pages/FundTransfer";

function App() {
  const [user, setUser] = useState(null);

  const handleLogout = () => {
    setUser(null);
  };

  // ❌ NOT LOGGED IN
  if (!user) {
    return <StaffLogin setUser={setUser} />;
  }

  return (
    <BrowserRouter>
      <Header user={user} onLogout={handleLogout} />

      <Routes>
        <Route
          path="/"
          element={<Layout user={user} onLogout={handleLogout} />}
        >
          {/* DASHBOARD */}
          <Route index element={<Dashboard />} />

          {/* MEMBER */}
          <Route path="member-registration" element={<MemberRegistration />} />
          <Route path="member-detail" element={<MemberDetail />} />
          <Route
            path="group-details/:memberId"
            element={<GroupDetails user={user} />}
          />

          {/* SAVING */}
          <Route path="open-saving" element={<OpenSaving user={user} />} />
          <Route
            path="saving-ledger"
            element={<SavingLedger user={user} />}
          />

          {/* REPORT */}
          <Route path="day-book" element={<DayBook />} />
          <Route path="due-members" element={<DueMembers />} />
          <Route path="advance-members" element={<AdvanceMembers />} />

          {/* 🔐 ADMIN ONLY */}
          {user.role === "ADMIN" && (
            <>
              <Route path="create-staff" element={<CreateStaff />} />
              <Route path="staff-list" element={<StaffList />} />

              {/* 🔥 OFFERS */}
              <Route path="offers" element={<Offers user={user} />} />

              {/* 🔥 FUND TRANSFER (ADMIN) */}
              <Route
                path="fund-transfer"
                element={<FundTransfer user={user} />}
              />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;